import React from 'react'
import NumberField from '../../shared/NumberField'
import {
  useWatch,
  Control,
  UseFormTrigger,
  UseFormGetValues,
  UseFormResetField,
  UseFormSetValue,
  Path,
  RegisterOptions,
} from 'react-hook-form'
import { FormValues } from '../..'
import { useTranslation } from 'react-i18next'

interface Props {
  control: Control<FormValues>
  trigger?: UseFormTrigger<FormValues>
  getValues: UseFormGetValues<FormValues>
  resetField: UseFormResetField<FormValues>
  setValue?: UseFormSetValue<FormValues>
  name?: Path<FormValues>
  rules?: RegisterOptions
}

const ForestCover = (props: Props) => {
  const { t } = useTranslation()
  const { control, trigger, getValues } = props

  const watch = useWatch({ control, name: 'property.extras.nonForest' })

  React.useEffect(() => {
    trigger?.('property.forestCover')
  }, [watch, trigger])

  return (
    <NumberField
      title="createPropertyAdFields.forestCover.label"
      titleProps={{ required: false }}
      translateTitle
      control={control}
      name={'property.forestCover' as Path<FormValues>}
      rules={{
        validate: {
          dependant: (v) => {
            const dep = getValues('property.extras.nonForest')
            if ((dep === 'non_forest' && !!v) || (dep === '' && !!v)) {
              return t('manageEstateAd.mustNotHaveValue') as unknown as string
            }
            return true
          },
          isLessThatOne: (value) => {
            if (value === '') return true
            else if (Number(value) > 1) {
              return t(
                `manageEstateAd.isNotGreaterThanOne`
              ) as unknown as string
            }
          },
        },
      }}
    />
  )
}

export default React.memo(ForestCover)
